export default {
  GatewayCpe: '网关设备',
  GatewayStatu: '网关状态',
  Accesspoint: '接入点',
  Branch: ' 分支机构',
  Bandwidth: '采购带宽（bps）',
  StartTime: '最近启用时间',
  ToBeActivated: '待启用',
  InUse: '启用中',
  FailedToEnable: '启用失败',
  InService: '服务中',
  Deactivated: '已停用',
  ServiceException: '服务异常',
  Disable: '禁用',
  Resource: '资源监控',
  SearchPlaceholder: '搜索设备号/设备别名/网关号/分支机构',
  Gateway: '网关实例',
  Total: (total: number) => `共${total}项`,
  ActiveCpe: '激活设备',
  EnableGatewayCpe: '启用网关及关联设备',
  CpeType: '设备类型',
  CpeLabel: (num: number) => `设备${num}`,
  SNPlaceholder: '请输入设备License ID号后六位',
  SNRequire: 'License ID号不能为空，请按要求填写',
  SNConfirm: '设备校验',
  DisableContent: '禁用成功后，网关服务将被关闭。如有需要可再次启用网关。',
  DisableTitle: '确定禁用当前网关？',
  Retry: '重试',
  CpeToBeActive: '设备已初始化配置，可激活启用',
  CpeOnline: '设备在线',
  CpeOffline: '设备离线',
  CpeActiveError: '设备激活失败 请',
  CpeActive: '立即激活',
  CpeName: '物理机CPE',
  Isp1: '移动',
  Isp2: '电信',
  Isp3: '联通',
  Isp4: '其他',
  ActiveSuccess: '激活成功',
  EnableSuccess: '启用成功',
  DisableSuccess: '禁用成功',
  ToBeConfigured: '待配置',
  Deleted: '已删除',
  Reset: '重置',
  StopUseSuccess: '停用成功',
  StartConfiguration: '开局配置',
  CpeOfflineEmailConfigText: '设备离线，若您需要重置设备配置可使用',
  EmailConfig: '邮件配置',
  SendStartEmail: '发送开局邮件',
  CpeStartConfig: '设备开局配置',
  CpeNetworkAccess: '设备入网',
  Wired: '有线',
  Wireless: '无线',
  StartEmail: '开局邮箱',
  StartEmailError: '请输入正确的开局邮箱',
  SuccessSendEmailTitle: '设备开局邮件已发送，请注意查收！',
  SuccessSendEmailContent1: '登录邮箱按要求完成设备开局，开局成功后设备将切换至上线状态。',
  SuccessSendEmailContent2: '若您需要修改配置，请点击邮件配置入口修改后重新发送邮件，请勿直接在网关管理-网络配置下修改。短时间内频繁修改发送可能导致开局配置不同步, 请谨慎操作。',
  ErrorSendEmailContent: '当前设备为在线状态，不支持邮件配置。若您需要修改配置，请前往网关管理-网络配置下修改。',
  InputCpeConfig: '填写设备配置',
  Mode: '模式',
  TransparentMode: '透明模式',
  CommonMode: '通用模式',
  CpeLastTimeOnline: '设备最近上线时间',
  CpeLastTimeOffline: '设备最近离线时间',
  CpeLastTimeOnlineStart: '设备最近上线开始时间',
  CpeLastTimeOnlineEnd: '设备最近上线结束时间',
  CpeLastTimeOfflineStart: '设备最近离线开始时间',
  CpeLastTimeOfflineEnd: '设备最近离线结束时间',
  CurrentFlowLink: '当前流量转发链路',
}